<template>
  <main role="main" class="py-4">
    <b-container class="container-x">
      <!-- Title Section -->
      <div class="d-flex flex-row align-items-center justify-content-between mb-4 border-bottom pb-2">
        <h4 class="m-0 text-dark font-weight-bold">{{ $t("featureList") }}</h4>
        <b-button
            variant="primary"
            size="sm"
            class="d-flex align-items-center px-3 btn-create-custom"
            v-if="isUserAdmin()"
            @click="$bvModal.show('create-feature-modal')"
            >
            <b-icon icon="plus" class="mr-1" /> {{ $t("createNew") }}
        </b-button>
      </div>

      <!-- Config Card -->
      <b-card class="shadow-sm border">
        <!-- Thanh tìm kiếm -->
        <b-form class="d-flex flex-row align-items-center mb-4" @submit.prevent="configSearch">
          <div class="flex-shrink-0 mr-3 font-weight-bold text-secondary small">{{ $t("search") }}</div>

          <b-form-input type="search" v-model="searchText" minlength="2" maxlength="50"
            :placeholder="$t('tukhoatimkiem')"
            class="mr-3"
            style="max-width: 320px;"/>

          <b-button type="submit" variant="primary" style="min-width: 100px;">
            {{ $t("search") }}
          </b-button>
        </b-form>

        <!-- Bảng danh sách -->
        <b-table ref="table" :items="tableItemProvider" class="goicuoctable border" hover primary-key="id" :fields="tableFields" show-empty
          :per-page="itemsPerPage" :current-page="currentPage">
          <template v-slot:table-busy>
            <div class="text-center text-secondary py-4">
              <b-spinner variant="primary" small class="mr-2"></b-spinner>
              {{ $t("loadingData") }}
            </div>
          </template>
          <template v-slot:empty>
            <div class="text-center text-secondary py-4">{{ $t("noData") }}</div>
          </template>
          <template v-slot:cell(id)="data">
            {{ data.item.id }}
          </template>
          <template v-slot:cell(code)="data">
              {{ data.item.code }}  
          </template>
          <template v-slot:cell(name)="data">
              {{ data.item.name }}  
          </template>
          <template v-slot:cell(description) ="data">
            {{ data.item.description }}
          </template>
          <template v-slot:cell(isDefault)="data">
            <div class="text-center">
              <b-form-checkbox
                switch
                :checked="data.item.isDefault === enumStatus.ENABLE" 
                class="mb-0" size="lg"
                @change = "changeSwitch(data.item)">
              </b-form-checkbox>
            </div>
          </template>

          <template v-slot:cell(actions)="data">
            <!-- Cập nhật, xóa -->
            <template>
              <b-button @click="openEditModal(data.item)" variant="outline-primary" size="sm" class="mr-2" >{{ $t("update") }}</b-button>
              <b-button variant="outline-danger" size="sm" @click="onClickDeleteByCode(data.item)">{{ $t("actionDelete")}}</b-button>
            </template>
          </template>
        </b-table>

        <div class="d-flex flex-row justify-content-end mt-3">
          <div class="d-flex flex-row align-items-center">
            <div v-if="totalItems" class="text-right flex-shrink-0 mr-3 small text-secondary">{{ $t("resultCount", { count: totalItems }) }}</div>
            <b-pagination class="my-0 mr-3" v-model="currentPage" :total-rows="totalItems" :per-page="itemsPerPage"></b-pagination>
            <b-form-select v-model="itemsPerPage" :options="itemsPerPageSelections" style="width: auto;"></b-form-select>
          </div>
        </div>
      </b-card>
    </b-container>

    <b-modal id="create-feature-modal" v-model="showCreateConfigModal" :title="$t('createFeature')" hide-footer no-close-on-backdrop >
      <CreateConfigModal @createFeature="refreshData()"></CreateConfigModal>
    </b-modal>

    <b-modal id="edit-feature-modal" v-model="showEditConfigModal" :title="$t('editFeature')" hide-footer no-close-on-backdrop @createFeature = "refreshData">
      <EditConfigModal
        :code="editData.code"
        :name="editData.name"
        :description="editData.description"
        :isDefault = "editData.isDefault"
        @editFeature="refreshData()"/>
    </b-modal>
  </main>
</template>

<style lang="scss" scoped>
.container-x {
  max-width: 1200px;
}
.card {
  border-radius: 8px;
  background-color: #f4f9ff;
}
.font-weight-bold {
  font-weight: 600 !important;
}
.pre-line {
  white-space: pre-line;
}
.goicuoctable {
  // background-color: #ffffff;
  border-radius: 6px;
  overflow: hidden;
}
</style>

<script lang="ts">
import { Component, Ref, Vue } from 'vue-property-decorator';
import _ from "lodash";
import BaseComponent from "@/components/BaseComponent";
import { BvTableFieldArray } from "bootstrap-vue";
import { BTable, BvTableCtxObject, BvTableProviderPromiseResult } from "bootstrap-vue/src/components/table";
import * as featureConfigService from "@/service/featureConfigService";
import CreateConfigModal  from "@/views/manage-config/CreateConfigModal.vue";
import EditConfigModal from './EditConfigModal.vue';
import { Status } from '../enums/EnableStatus';

@Component({
  components: { CreateConfigModal, EditConfigModal  }
})
export default class ConfigList extends BaseComponent {
  // Status from enum ENABLE, DISABLE
  enumStatus = Status;
  showEditConfigModal = false;
  showCreateConfigModal = false;
  areaFilterSelectedOption = "";
  areaFilterOptions = [];
  subText = "";
  searchText = "";
  selectedSubs = [];
  areas = [];
  code = "";
  name = "";
  description ="";
  configList= [];
  editData= {
    code: '',
    name: '',
    description: '',
    isDefault:''
  };
  @Ref("table") table: BTable;
  tableFields: BvTableFieldArray = [
    {
      key: "id",
      label: "ID",
      thClass: "text-nowrap",
      tdClass: "text-break",
      thStyle: { width: "5%" },
    },
    {
      key: "code",
      label: "Mã",
      thClass: "text-nowrap",
      tdClass: "text-break",
      thStyle: { width: "15%" },
    },
    {
      key: "name",
      label: "Tên",
      thClass: "text-nowrap",
      tdClass: "text-break",
      thStyle: { width: "20%" },
    },
    {
      key: "description",
      label: "Mô tả",
      thClass: "customColumn",
      tdClass: "text-break",
      thStyle: { width: "40%" },
    },
    {
      key: "isDefault",
      label: "Luôn sử dụng",
      thClass: "text-nowrap",
      tdClass: "text-nowrap",
        thStyle: { width: "10%" },
    },
     {
      key: "actions",
      label: "",
      thClass: "text-nowrap",
      tdClass: "text-nowrap"
    }
  ];
  itemsPerPageSelections = [
    { value: 20, text: "20 " + this.$t("itemsPerPage").toString() },
    { value: 50, text: "50 " + this.$t("itemsPerPage").toString() },
    { value: 100, text: "100 " + this.$t("itemsPerPage").toString() },
    { value: 200, text: "200 " + this.$t("itemsPerPage").toString() },
  ];
  itemsPerPage = 20;
  currentPage = 1;
  totalItems = 0;
  userToEdit = null;
  isDefault= null;
  formErrorMsg = "";
  isSubmitting = false;

  mounted() {
  }

  refreshData() {
    this.table.refresh();
  }
  //gọi api lấy danh sách
  async tableItemProvider(ctx: BvTableCtxObject): Promise<BvTableProviderPromiseResult> {
    try {
      const res = await featureConfigService.getAll(ctx.currentPage, ctx.perPage, this.searchText.trim()|| "");
      this.totalItems = res.total;
      return res.data;
    } catch (e) {
      this.toastError(e);
    }
  }
  //refresh lại mỗi khi bấm tìm kiếm 
  async configSearch() {
    this.currentPage = 1;
    this.table.refresh();
  }

  async onClickDeleteByCode(code) {
    const modalMessage = this.$t("deleteFunctionConfirm", {
      name: code.name,
      id: code.code
    }).toString();    
    const confirmDelete = await this.$bvModal.msgBoxConfirm(modalMessage, {
      okVariant: "danger",
      okTitle: this.$t("yes").toString(),
      cancelTitle: this.$t("no").toString(),
      bodyClass: "text-break pre-line"
    });
    if (!confirmDelete) return;
    try {
      await featureConfigService.deleteByCode(code.code);
      this.refreshData();
      this.toastSuccessDelay(this.$t("deleteFunctionSuccessful").toString());
    } catch (error) {
      this.toastErrorOldType(error);
    }
  }

  //lắng nghe sự thay đổi từ switch btn
  async changeSwitch(item) {
    const changeIsDefault = item.isDefault === Status.ENABLE ? Status.DISABLE : Status.ENABLE;
    this.formErrorMsg = "";
    this.isSubmitting = true;
    try {
      const data = {
        code: item.code.trim(),
        name: item.name.trim(),
        description: item.description?.trim() || "",
        isDefault: changeIsDefault ? Status.ENABLE : Status.DISABLE
      };
      await featureConfigService.updateByCode(data);
      item.isDefault = changeIsDefault;
    } 
    catch (e) {
      this.toastErrorOldType(e);  
    } finally {
      this.isSubmitting = false;
      
    }
  }
  //Lưu giá trị khi truyền cho Component
  openEditModal(item) {
    this.editData = { ...item };
    this.showEditConfigModal = true;
  }
}
</script>
